export default "/assets/images/vexcode-vr-logo.svg";